export default function abPagejsCallback(originalCallback, variantName) {
  return (ctx, next) => callOriginalCallbackOrIgnore(originalCallback, variantName, ctx, next);
}

function callOriginalCallbackOrIgnore(originalCallback, variantName, ctx, next) {
  if (ctx.winningFullPageVariantName === variantName) {
    return originalCallback.call(originalCallback, ctx, next);
  }

  return next();
}



// WEBPACK FOOTER //
// ./src/modules/ab-page-js/utils/index.js